
import React, { useContext, useState, useEffect, useCallback } from "react";
import { CurrencySign, nFormatter } from "../../api/ReplayVariables";
import { sendCommand } from "../components/Bridge";
import "./SessionResults.scss";

import { SessionContext } from "./state/SessionContext";
import { SESSION_ACTIONS } from "./state/SessionReducer";

function SessionResults({match}){

    const { sessionState, dispatchSessionState } = useContext(SessionContext);
    const [lastNodeId, setLastNodeId] = useState(-1000);
    const [currency, setCurrency] = useState("");
    const [netGain, setNetGain] = useState(0);
    const [roi, setRoi] = useState(null);
    const [itm, setItm] = useState(null);
    const [buyIn, setBuyIn] = useState(null);

    const loadData= useCallback(()=>{
        let params= match.params;
        sendCommand("session/results", {
            sessionType : params.sessionType,
            hero : params.hero,
            nodeId : params.nodeId,
            sort : "",
            dir : "",
            groupBy : sessionState.resultsGroupBy
        }).then((response)=>{
            let results= response.data;
            dispatchSessionState({
            type: SESSION_ACTIONS.RESULTS_UPDATED,
            payload: results
            });
            setNetGain(sessionState.results.data[0].netGain);
            setCurrency(CurrencySign[sessionState.results.info]);
            setRoi(sessionState.results.data[0].totalBuyins>0?Math.round(sessionState.results.data[0].netGain*100/sessionState.results.data[0].totalBuyins):null);
            setItm(sessionState.results.data[0].nbSessions>0?Math.round(sessionState.results.data[0].nbInTheMoney*100/sessionState.results.data[0].nbSessions):null);
            setBuyIn(sessionState.results.data[0].nbSessions>0?nFormatter(sessionState.results.data[0].totalBuyins/sessionState.results.data[0].nbSessions):null);
        }).catch(err=>{
            console.error("getResults error", err);
        });

    }, [dispatchSessionState, match.params, sessionState.results.data, sessionState.results.info, sessionState.resultsGroupBy]);

    useEffect(()=>{
        console.log("results effect");
        let timer;
        if(lastNodeId!==match.params.nodeId){
            timer= setTimeout(()=>{
                loadData();
                setLastNodeId(u=>match.params.nodeId);
            }, 100);
        }
        return ()=>{
            if(timer){
                clearTimeout(timer);
            }
            console.log("results effect done");
        }
    }, [match, sessionState.results, loadData, lastNodeId]);

    return (
        <div className="list-summary">
            <div className="summary-header">Résultats</div>
            {sessionState.results.total>0?
            <table striped={true} hover={true}> 
                <thead>
                    <tr>
                        <th>Métrique</th>
                        <th>Valeur</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Net</td>
                        <td>{netGain} {currency}</td>
                    </tr>
                    <tr>
                        <td>ROI</td>
                        <td>{roi!==null?roi+" %":"-"}</td>
                    </tr>
                    <tr>
                        <td>ITM%</td>
                        <td>{itm!==null?itm+" %":"-"}</td>
                    </tr>
                    <tr>
                        <td>Avg. BuyIn</td>
                        <td>{buyIn!==null?buyIn + " "+currency:"-"}</td>
                    </tr>
                    <tr>
                        <td>Sessions</td>
                        <td>{sessionState.results.data[0].nbSessions}</td>
                    </tr>
                    <tr>
                        <td>Sessions</td>
                        <td>{sessionState.results.data[0].nbSessions}</td>
                    </tr>
                    <tr>
                        <td>Sessions</td>
                        <td>{sessionState.results.data[0].nbSessions}</td>
                    </tr>
                </tbody>
            </table>:<></>}
        </div>
    )
}
export default SessionResults;